import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

import { User } from '@app/_models';
import { UserService } from '@app/_services';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {
    loading = false;
    users: User[];
    storage: Storage;
    currentRole: string;
    currentRoleJson: string;
    currentToken: string;
    returnUrl;

    constructor(private userService: UserService,  private router: Router) { }

    // ngOnInit() {
    //     this.loading = true;
    //     this.userService.getAll().pipe(first()).subscribe(users => {
    //         this.loading = false;
    //         this.users = users;
    //     });
    //     this.storage = window.localStorage;
    //     this.currentRole = this.storage.currentRole;
    //     this.currentToken
    //     // console.log("CURRENTUSER",this.currentRole);
    //    this.currentRoleJson = JSON.parse(this.currentRole);
    //    console.log("CURRENTUSER",this.currentRoleJson);
    //     this.currentToken = this.storage.token;
    //     console.log("token", this.currentToken)

    //     if(this.currentRoleJson == "student" && this.currentToken != ""){
    //         console.log("role = student")
    //         this.returnUrl = "student";
    //         this.router.navigate([this.returnUrl]);
    //     }

    //     if(this.currentRoleJson == "verifier" && this.currentToken != ""){
    //         console.log("role = verifier")
    //         this.returnUrl = "verifier";
    //         this.router.navigate([this.returnUrl]);
    //     }

    //     if(this.currentRoleJson == "superVerifier" && this.currentToken != ""){
    //         console.log("role = super verifier")
    //         this.returnUrl = "superVerifier";
    //         this.router.navigate([this.returnUrl]);
    //     }

    //     if(this.currentRoleJson == "associate" && this.currentToken != ""){
    //         console.log("role = associate")
    //         this.returnUrl = "associate";
    //         this.router.navigate([this.returnUrl]);
    //     }

    //     if(this.currentRoleJson == "superAssociate" && this.currentToken != ""){
    //         console.log("role = super associate")
    //         this.returnUrl = "superAssociate";
    //         this.router.navigate([this.returnUrl]);
    //     }

    //     if(this.currentRoleJson == "superAdmin" && this.currentToken != ""){
    //         console.log("role = super admin")
    //         this.returnUrl = "superAdmin";
    //         this.router.navigate([this.returnUrl]);
    //     }

    //     if(this.currentRoleJson == "university" && this.currentToken != ""){
    //         console.log("role = university")
    //         this.returnUrl = "university";
    //         this.router.navigate([this.returnUrl]);
    //     }
    // }
}